import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GestureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gesture"}/>
}
